import { X } from "lucide-react";
import type { FC } from "react";

import type {
  OutgoingIntake,
  OutgoingIntakeFormNode
} from "@/api/types/outgoingIntake";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle
} from "@/components/ui/dialog";

import { IntakePreview } from "../editor/PreviewPane";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  intake: OutgoingIntake | null;
  /** The live draft's questions, when previewing unsaved edits. */
  schema?: OutgoingIntakeFormNode[];
  clientName?: string | null;
};

/** "Preview": the client's view of the intake, Desktop or Phone, over the page. */
export const PreviewDialog: FC<Props> = ({
  open,
  onOpenChange,
  intake,
  schema,
  clientName
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      showCloseButton={false}
      className="flex h-[88vh] w-[min(1100px,94vw)] max-w-none flex-col gap-0 overflow-hidden p-0 sm:max-w-none"
      aria-describedby={undefined}
    >
      <DialogTitle className="sr-only">
        Preview of {intake?.title || "the intake"}
      </DialogTitle>
      {open ? (
        <IntakePreview
          intake={intake}
          schema={schema}
          clientName={clientName}
          actions={
            <DialogClose asChild>
              <Button variant="ghost" size="icon-sm" aria-label="Close Preview">
                <X />
              </Button>
            </DialogClose>
          }
        />
      ) : null}
    </DialogContent>
  </Dialog>
);
